import { useAddress } from "../hooks/useAddress";

export const Geocode = ({ lat, lng }) => {
  const {address} = useAddress({ lat, lng });
  if(!address) return (<span>{"-"}</span>)
  return <span>{address.jibunAddress}</span>
}